export default __webpack_public_path__ + "static/media/Gloves of the Exorcist.38080f88.jpg";